import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../providers/api.service';
import { ToastrService } from 'ngx-toastr';
import { isEmptyObject } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { headerMenu, platformList, sportList } from '../shared.service';
import { NavService } from '../providers/nav.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  @ViewChild('myContactForm', { static: false }) myContactForm;
  @Input()
  center: boolean;
  contactusForm: FormGroup;
  submitted = false;
  contactDet: any = {};

  // subscriptionItems: any = { items: [] };
  // userSubscriptionList: any = {};
  // checkSubscirptionPlanlist: any;

  // subTotal: any = 0;
  // mainTotal: any = 0;
  loginUserDetails: any = {};
  handler: any = null;

  upgradeDisplay = 'none';
  contactDisplay = 'none';

  platformList = platformList;
  sportList = sportList;
  activeMenu = headerMenu.plan;
  packageDetails = [];
  selectedPackageTotal = 0;

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
  ) {
    this.loginUserDetails = JSON.parse(localStorage.getItem('userDetails'));
  }

  ngOnInit() {
    console.log(this.center)
    this.contactusForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
    this.loadStripe();
  }

  loadStripe() {
    if (!window.document.getElementById('stripe-script')) {
      const s = window.document.createElement('script');
      s.id = 'stripe-script';
      s.type = 'text/javascript';
      s.src = 'https://checkout.stripe.com/checkout.js';
      s.onload = () => {
        this.handler = (window as any).StripeCheckout.configure({
          // key: 'pk_test_aeUUjYYcx4XNfKVW60pmHTtI',
          key: 'pk_test_51HbLWrAFcfh8Mf7ZnkhqV6q4vyKYV0bDFZC2OJ4q8IUOiT0IC4wfCTTdxB9ePnqO7jsNw5TwieJUpwqzQwMoqD3C00EzoZpAoL',
          locale: 'auto',
          token(token: any) {
            // You can access the token ID with `token.id`.
            // Get the token ID to your server-side code for use.
            // console.log(token);
            alert('Payment Success!!');
          }
        });
      };
      window.document.body.appendChild(s);
    }

  }

  get f() {
    return this.contactusForm.controls;
  }

  openContactModalDialog() {
    this.myContactForm.resetForm();
    this.submitted = false;
    this.contactDet = {};
    this.contactDisplay = 'block';
  }

  onSubmit() {
    this.submitted = true;
    if (this.contactusForm.valid) {
      // console.log('contact us form valid' + this.contactDet);
      this.SpinnerService.show();
      this.api.contactUs(this.contactDet).subscribe(data => {
        this.SpinnerService.hide();
        this.contactDisplay = 'none';
        if (data && data.code == 100) {
          this.submitted = false;
          this.contactDet = {};
          this.toastr.success(data.message, 'Success');
        } else {
          this.toastr.warning(data.message, 'Warning');
        }
      }, (err) => {
        this.SpinnerService.hide();
        this.contactDisplay = 'none';
        this.toastr.error('Somthing Went wrong', 'Error');
      });
    } else {
      // console.log('contact us form invalid');
    }
  }


  openModalDialog() {
    // this.userSubscriptionList = JSON.parse(localStorage.getItem('userSubscriptionList'));
    // if (!isEmptyObject(this.packageDetails)) {
    //   this.packageDetails.forEach(element => {
    //     this.userSubscriptionList.forEach(innerele => {
    //       if (element.package_id == innerele.package_id) {
    //         if (innerele.plan == 'month') {
    //           element.isMonthlyCheck = true;
    //           element.isAnnualCheck = false;
    //         } else if (innerele.plan == 'year') {
    //           element.isAnnualCheck = true;
    //           element.isMonthlyCheck = false;
    //         } else {
    //           element.isMonthlyCheck = false;
    //           element.isAnnualCheck = false;
    //         }
    //       }
    //     });
    //   });
    // }
    // this.checkSubscirptionPlanlist = this.packageDetails;
    // this.subTotalPrice();

    this.packageDetails = JSON.parse(localStorage.getItem('PackageDetails'));
    if (this.packageDetails && this.packageDetails.length > 0) {
      this.packageDetails.forEach(element => {
        element.isMonthlyCheck = false;
        element.isAnnualCheck = false;
      });
    }
    this.upgradeDisplay = 'block';
  }

  changePackage(item, isFrom) {
    if (item.package_id == 4) {
      const tmp = JSON.parse(JSON.stringify(item));
      this.packageDetails.forEach(element => {
        element.isMonthlyCheck = false;
        element.isAnnualCheck = false;
      });

      if (isFrom == 1) {
        if (tmp.isMonthlyCheck) { item.isMonthlyCheck = true; }
      } else {
        if (tmp.isAnnualCheck) { item.isAnnualCheck = true; }
      }
    } else {
      const tmp = this.packageDetails.find(m => m.package_id == 4);
      if (!tmp.isMonthlyCheck && !tmp.isAnnualCheck) {
        if (isFrom == 1) {
          if (item.isMonthlyCheck) { item.isAnnualCheck = false; }
        } else {
          if (item.isAnnualCheck) { item.isMonthlyCheck = false; }
        }
      } else {
        tmp.isAnnualCheck = false;
        tmp.isMonthlyCheck = false;
      }
    }
    // this.getCheckedList();
  }

  // getCheckedList() {
  //   this.checkSubscirptionPlanlist = [];
  //   this.packageDetails.forEach(element => {
  //     if (element.isMonthlyCheck || element.isAnnualCheck) {
  //       this.checkSubscirptionPlanlist.push(element);
  //     }
  //   });

  //   this.subscriptionItems.items = [];
  //   this.checkSubscirptionPlanlist.forEach(element => {
  //     const tempPlan: any = {};
  //     if (element.isAnnualCheck == true) {
  //       tempPlan.amount = element.annual_price;
  //       tempPlan.package_id = element.package_id;
  //       tempPlan.plan = 'year';

  //       this.subscriptionItems.items.push(tempPlan);
  //     } else if (element.isMonthlyCheck == true) {
  //       tempPlan.amount = element.monthly_price;
  //       tempPlan.package_id = element.package_id;
  //       tempPlan.plan = 'month';
  //       this.subscriptionItems.items.push(tempPlan);
  //     }
  //   });
  // }

  // subTotalPrice() {
  //   this.subTotal = 0;
  //   if (this.checkSubscirptionPlanlist) {
  //     this.checkSubscirptionPlanlist.forEach(ele => {
  //       if (ele.isMonthlyCheck) {
  //         this.subTotal = this.subTotal + ele.monthly_price;
  //       } else if (ele.isAnnualCheck) {
  //         this.subTotal = this.subTotal + ele.annual_price;
  //       }
  //     });
  //   }
  //   this.mainTotal = this.subTotal;
  //   return this.subTotal;
  // }


  onUpgrade() {
    this.packageDetails.forEach(element => {
      if (element.isMonthlyCheck) { this.selectedPackageTotal = this.selectedPackageTotal + element.monthly_price; }
      if (element.isAnnualCheck) { this.selectedPackageTotal = this.selectedPackageTotal + element.annual_price; }
    });

    if (this.selectedPackageTotal > 0) {
      const _self = this;
      const handler = (window as any).StripeCheckout.configure({
        // key: 'pk_test_aeUUjYYcx4XNfKVW60pmHTtI',  //dummy key
        key: 'pk_test_51HbLWrAFcfh8Mf7ZnkhqV6q4vyKYV0bDFZC2OJ4q8IUOiT0IC4wfCTTdxB9ePnqO7jsNw5TwieJUpwqzQwMoqD3C00EzoZpAoL',
        locale: 'auto',
        token(token: any) {
          // console.log(token);
          _self.insertPaymentDetails(token.id, token.email);
        }
      });
      handler.open({
        name: 'Chalk Faders',
        // description: '2 widgets',
        amount: this.selectedPackageTotal * 100,
        email: this.loginUserDetails.userDetails.email || ''
      });
    } else {
      this.toastr.error('Select at least one package', 'Pick a new plan');
      return;
    }
  }

  insertPaymentDetails(token, email) {
    const subscriptionItems: any = { items: [] };

    this.packageDetails.forEach(element => {
      const tempPlan: any = {};
      if (element.isAnnualCheck) {
        tempPlan.amount = element.annual_price;
        tempPlan.package_id = element.package_id;
        tempPlan.plan = 'year';
        subscriptionItems.items.push(tempPlan);
      } else if (element.isMonthlyCheck) {
        tempPlan.amount = element.monthly_price;
        tempPlan.package_id = element.package_id;
        tempPlan.plan = 'month';
        subscriptionItems.items.push(tempPlan);
      }
    });

    const tempData: any = {};

    tempData.device_token = '-';
    tempData.device_type = '3';
    tempData.token = token;
    tempData.user_id = this.loginUserDetails.user_id;
    tempData.referral_user_id = '';
    tempData.promo_code = ''; // this.ReferralCode
    tempData.email = email;
    tempData.name = email;
    tempData.items = JSON.stringify(subscriptionItems);

    this.SpinnerService.show();
    this.api.paymentDetails(tempData).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code == 100) {
        this.activeMenu = 4;
        localStorage.setItem('userSubscriptionList', JSON.stringify(data.data.userSubscriptionList));
        this.toastr.success('Payment Success', 'success');
      } else {
        this.toastr.warning('Somthing went wrong', 'Warning');
      }
    }, (err) => {
      this.SpinnerService.hide();
      // console.log(err);
    });
  }

  closeModalDialog() {
    this.activeMenu = 2;
    this.upgradeDisplay = 'none';
    this.contactDisplay = 'none';
  }
}
